var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-img',{attrs:{"max-width":"100px","src":_vm.message.image},on:{"click":function($event){_vm.overlay=true}}}),_c('v-overlay',{attrs:{"value":_vm.overlay},on:{"click":function($event){_vm.overlay = false}}},[_c('v-img',{staticClass:"mx-auto",attrs:{"max-width":"50%","src":_vm.message.image}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }